module.exports = __webpack_public_path__ + "img/title-2.4d971dfd.png";